import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  private readonly renderer: Renderer2;
  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  setFavicon(iconUrl: string): void {
    console.log('setFavicon', iconUrl);
    const link: HTMLLinkElement | null =
      document.querySelector("link[rel*='icon']");
    if (link) {
      this.renderer.setAttribute(link, 'href', iconUrl);
    } else {
      const newLink = this.renderer.createElement('link');
      this.renderer.setAttribute(newLink, 'rel', 'icon');
      this.renderer.setAttribute(newLink, 'href', iconUrl);
      const head = document.querySelector('head');
      if (head) {
        this.renderer.appendChild(head, newLink);
      }
    }
  }
}
